import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

import { ConditionGuideModalComponent } from './condition-guide-modal.component';
import { ConditionGuideModule } from '../condition-guide/condition-guide.module';

@NgModule({
  imports: [CommonModule, MatDialogModule, ConditionGuideModule],
  exports: [ConditionGuideModalComponent],
  declarations: [ConditionGuideModalComponent],
  entryComponents: [ConditionGuideModalComponent]
})
export class ConditionGuideModalModule {}
